export enum ReceiptPaymentType {
    Cash = 1,
    Transfer = 2
}